import { z } from 'zod';

export const adminRoleSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
});

export const adminUserSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  full_name: z.string().nullable(),
  active: z.boolean(),
  created_at: z.string(),
  roles: z.array(adminRoleSchema),
});

export const adminUsersResponseSchema = z.object({
  data: z.array(adminUserSchema),
});

export const adminRolesResponseSchema = z.object({
  data: z.array(adminRoleSchema),
});

export const adminMutationResponseSchema = z.object({
  data: z.object({ id: z.uuid() }),
});
